const appConfig = {
    apiPrefix: '/api',
    // apiURL: 'http://localhost:8000',
    // appURL: 'http://localhost:3000',
    // apiURL: 'https://st-api.siteworxit.solutions',
    // appURL: 'https://st-dashboard.siteworxit.solutions',
    apiURL: 'https://api.zigma.initcircle.com',
    appURL: 'https://zigma.initcircle.com',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    unVerifiedEntryPath: '/verify',
    tourPath: '/',
    enableMock: false,
    // defaultAdminID: 3,
    defaultAdminID: 1,
}

export const getTransactionHashURL = (transactionHash) => {
    let url;
    const transactionHashURL = "https://tronscan.org/#/transaction/";
    try {
        url = new URL(transactionHash);
    } catch (_) {
        return transactionHashURL + transactionHash;
    }

    if (url.protocol === 'http:' || url.protocol === 'https:') {
        // if URL, return original hash
        return transactionHash;
    }

    return transactionHashURL + transactionHash;
};

export default appConfig